Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var _default=[{
fontFamily:'AntDesign',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/AntDesign.ttf')
},{
fontFamily:'Entypo',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Entypo.ttf')
},{
fontFamily:'FontAwesome',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/FontAwesome.ttf')
},{
fontFamily:'HK Grotesk Black Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Black Italic.otf')
},{
fontFamily:'HK Grotesk Black',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Black.otf')
},{
fontFamily:'HK Grotesk Bold Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Bold Italic.otf')
},{
fontFamily:'HK Grotesk Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Bold.otf')
},{
fontFamily:'HK Grotesk Extra Bold Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Extra Bold Italic.otf')
},{
fontFamily:'HK Grotesk Extra Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Extra Bold.otf')
},{
fontFamily:'HK Grotesk Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Italic.otf')
},{
fontFamily:'HK Grotesk Light Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Light Italic.otf')
},{
fontFamily:'HK Grotesk Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Light.otf')
},{
fontFamily:'HK Grotesk Medium Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Medium Italic.otf')
},{
fontFamily:'HK Grotesk Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Medium.otf')
},{
fontFamily:'HK Grotesk Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Regular.otf')
},{
fontFamily:'HK Grotesk Semi Bold Italic',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Semi Bold Italic.otf')
},{
fontFamily:'HK Grotesk Semi Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk Semi Bold.otf')
},{
fontFamily:'HK Grotesk',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/HK Grotesk.otf')
},{
fontFamily:'Ionicons',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Ionicons.ttf')
},{
fontFamily:'MaterialCommunityIcons',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/MaterialCommunityIcons.ttf')
},{
fontFamily:'MaterialIcons',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/MaterialIcons.ttf')
},{
fontFamily:'Roboto Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto Bold.ttf')
},{
fontFamily:'Roboto Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto Light.ttf')
},{
fontFamily:'Roboto Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto Medium.ttf')
},{
fontFamily:'Roboto',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/base/fonts/Roboto.ttf')
},{
fontFamily:'DAZN Oscine Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/DAZN Oscine Bold.ttf')
},{
fontFamily:'DAZN Oscine ExtraBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/DAZN Oscine ExtraBold.ttf')
},{
fontFamily:'DAZN Oscine Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/DAZN Oscine Light.ttf')
},{
fontFamily:'DAZN Oscine Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/DAZN Oscine Regular.ttf')
},{
fontFamily:'Funnel Display Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Funnel Display Bold.ttf')
},{
fontFamily:'Funnel Display ExtraBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Funnel Display ExtraBold.ttf')
},{
fontFamily:'Funnel Display Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Funnel Display Light.ttf')
},{
fontFamily:'Funnel Display Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Funnel Display Medium.ttf')
},{
fontFamily:'Funnel Display Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Funnel Display Regular.ttf')
},{
fontFamily:'Funnel Display SemiBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Funnel Display SemiBold.ttf')
},{
fontFamily:'Montserrat Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat Bold.otf')
},{
fontFamily:'Montserrat ExtraBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat ExtraBold.otf')
},{
fontFamily:'Montserrat ExtraLight',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat ExtraLight.otf')
},{
fontFamily:'Montserrat Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat Light.otf')
},{
fontFamily:'Montserrat Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat Medium.otf')
},{
fontFamily:'Montserrat Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat Regular.otf')
},{
fontFamily:'Montserrat SemiBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat SemiBold.otf')
},{
fontFamily:'Montserrat Thin',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat Thin.otf')
},{
fontFamily:'Montserrat UltraLight',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Montserrat UltraLight.otf')
},{
fontFamily:'Outfit Black',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit Black.ttf')
},{
fontFamily:'Outfit Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit Bold.ttf')
},{
fontFamily:'Outfit ExtraBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit ExtraBold.ttf')
},{
fontFamily:'Outfit ExtraLight',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit ExtraLight.ttf')
},{
fontFamily:'Outfit Light',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit Light.ttf')
},{
fontFamily:'Outfit Medium',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit Medium.ttf')
},{
fontFamily:'Outfit Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit Regular.ttf')
},{
fontFamily:'Outfit SemiBold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit SemiBold.ttf')
},{
fontFamily:'Outfit Thin',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Outfit Thin.ttf')
},{
fontFamily:'Play Bold',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Play Bold.ttf')
},{
fontFamily:'Play Regular',
file:require('/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/appConfigs/tent/fonts/Play Regular.ttf')
}];exports.default=_default;